import React from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import languageSwitchStyles from './LanguageSwitch.module.scss';
import { useRealPathName } from 'lib/hooks/sitecore/useRealPathName';
import { useQueryString } from 'lib/hooks/browser/useQueryString';

export interface LanguageLinkData {
  text?: string;
  locale: string;
}
export interface LanguageSwitchProps {
  className?: string;
  caption?: string;
  links: LanguageLinkData[];
}

export const LanguageSwitch = (props: LanguageSwitchProps) => {
  const router = useRouter();
  const pathname = useRealPathName();
  const query = useQueryString();
  return (
    <div className={clsx(languageSwitchStyles.component_language, props.className, 'printHide')}>
      <ul aria-label="Languages" className={languageSwitchStyles.language_item}>
        {props.links?.map((link) => {
          const displayText =
            link.text && link.text.trim().length > 0 ? link.text.trim() : link.locale;
          const targetLocale = link.locale;
          const key = `${targetLocale}-${displayText}`;

          // Normalize both sides to compare current vs target locale
          const isCurrent =
            (router.locale || '').toLowerCase() === (targetLocale || '').toLowerCase();

          return (
            <li key={key}>
              <NextLink
                href={{ pathname, query: query.toString() }}
                locale={targetLocale.toLowerCase()}
                aria-current={isCurrent ? 'page' : undefined}
                tabIndex={isCurrent ? -1 : 0}
              >
                <span lang={targetLocale}>{displayText}</span>
              </NextLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
